export const ANNOTATION_COMMENT_BUTTON = 'annotationCommentButton'
export const ANNOTATION_COMMENT_CONTEXTUAL_BUTTON =
  'annotationCommentContextualButton'

export const ANNOTATION_POPUP_BUTTONS_TO_KEEP = [ANNOTATION_COMMENT_BUTTON]
export const ANNOTATION_TEXT_POPUP = 'textPopup'
export const ANNOTATION_TOOLBAR_GROUP_BUTTON = 'toolbarGroup-Annotate'
export const ANNOTATION_SELECT_TOOL_BUTTON = 'selectToolButton'
export const ANNOTATION_RECTANGLE_TOOL_BUTTON = 'shapeToolGroupButton'

export const ANNOTATION_TOOLS_HEADER = 'toolsHeader'
export const TEXT_SELECT_TOOL = 'TextSelect'
export const ANNOTATION_HIGHLIGHT_TOOL = 'AnnotationCreateTextHighlight'
export const ANNOTATION_RECTANGLE_TOOL = 'AnnotationCreateRectangle'
export const ANNOTATION_HEADER_RECTANGLE_TOOL = 'rectangleTools'

export const ANNOTATION_DESELECTED_ACTION = 'deselected'
export const ANNOTATION_SELECTED_ACTION = 'selected'

export const ANNOTATION_CHANGED_ACTIONS = {
  ADDED: 'add',
  UPDATED: 'modify',
  DELETED: 'delete',
}

export const ANNOTATION_CHANGED_EVENT = 'annotationChanged'
export const ANNOTATION_SELECTED_EVENT = 'annotationSelected'
export const ANNOTATIONS_LOADED_EVENT = 'annotationsLoaded'
export const DOCUMENT_LOADED_EVENT = 'documentLoaded'
export const PAGE_COMPLETE_EVENT = 'pageComplete'
export const TEXT_SELECTED_EVENT = 'textSelected'

// Alpha-blended with ANNOTATION_RECTANGLE_FILL_OPACITY should ~equal the text highlight color above.
// NOTE: if the opacity is changed, the rectangle fill color NEEDS to be recalculated.
// For each of R,G,B components, solve X_NEW for: X_OLD = 255 - OPACITY * (255 - X_NEW)
const ANNOTATION_RECTANGLE_FILL_RGB = [255, 225, 85]
export const ANNOTATION_RECTANGLE_FILL_OPACITY = 0.6
export const ANNOTATION_RECTANGLE_FILL_COLOR =
  ANNOTATION_RECTANGLE_FILL_RGB.concat(ANNOTATION_RECTANGLE_FILL_OPACITY)
export const ANNOTATION_RECTANGLE_FILL_COLOR_OPAQUE =
  ANNOTATION_RECTANGLE_FILL_RGB.concat(1)
export const ANNOTATION_RECTANGLE_STROKE_COLOR = [0, 0, 0]
export const ANNOTATION_RECTANGLE_THICKNESS = 1
export const ANNOTATION_RECTANGLE_COLOR = [234, 64, 37, 1]

export const ANNOTATION_HIGHLIGHT_COLOR = [255, 237, 153, 1]

export const ANNOTATION_BUBBLE_RADIUS = 3.5
export const ANNOTATION_BUBBLE_WIDTH = 1.5
